import React, { useState } from "react";
import api from "../api/client";

export default function BinnedDataSearchDashboard() {
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------------------------------
      SEARCH BINNED DATA
  ---------------------------------------- */
  const handleSearch = async () => {
    setLoading(true);
    try {

      const res = await api.get("/api/reports/binned", {
        params: { search: searchTerm }
      });

      setTableData(res.data?.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch binned inventory");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>
        <h2 style={styles.title}>Binned Inventory Search</h2>
        <p style={styles.subtitle}>
          Quickly locate binned inventory using SKU or ASN number
        </p>
      </div>

      {/* SEARCH BAR */}
      <div style={styles.searchCard}>
        <input
          type="text"
          style={styles.searchInput}
          placeholder="Search by SKU or ASN Number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />

        <button style={styles.searchBtn} onClick={handleSearch}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {/* RESULT SUMMARY */}
      <div style={styles.summary}>
        {tableData.length > 0 && (
          <span>
            Showing <strong>{tableData.length}</strong> result
            {tableData.length > 1 ? "s" : ""}
          </span>
        )}
      </div>

      {/* RESULTS TABLE */}
      <div style={styles.card}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ASN Number</th>
              <th style={styles.th}>Location ID</th>
              <th style={{ ...styles.th, textAlign: "center" }}>
                Total Pieces
              </th>
              <th style={styles.th}>SKU</th>
              <th style={styles.th}>Binned Date</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={styles.emptyCell}>
                  Loading results...
                </td>
              </tr>
            ) : tableData.length === 0 ? (
              <tr>
                <td colSpan="5" style={styles.emptyCell}>
                  No binned inventory found
                </td>
              </tr>
            ) : (
              tableData.map((row, i) => (
                <tr
                  key={i}
                  style={i % 2 === 0 ? styles.rowEven : styles.rowOdd}
                >
                  {/* ✅ FIXED FIELD NAMES */}
                  <td style={styles.td}>{row.ASN}</td>
                  <td style={styles.td}>{row.LocationID}</td>
                  <td
                    style={{
                      ...styles.td,
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    {row.TotalPieces}
                  </td>
                  <td style={styles.td}>{row.SKU}</td>
                  <td style={styles.td}>{row.SubmittedDate}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}

/* ---------------------------------------
      DASHBOARD STYLES (UNCHANGED)
---------------------------------------- */
const styles = {
  page: {
    padding: "2rem",
    background: "#f5f7fb",
    minHeight: "100vh",
    fontFamily: "Inter, Arial, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "1.8rem",
  },
  title: {
    margin: 0,
    fontSize: "2rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  subtitle: {
    marginTop: "0.4rem",
    color: "#6b7280",
    fontSize: "0.95rem",
  },
  searchCard: {
    maxWidth: "700px",
    margin: "0 auto 1.5rem",
    display: "flex",
    gap: "0.75rem",
    background: "#fff",
    padding: "1rem",
    borderRadius: "14px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
  },
  searchInput: {
    flex: 1,
    padding: "0.9rem 1rem",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    fontSize: "1rem",
  },
  searchBtn: {
    padding: "0.9rem 1.6rem",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: 600,
    cursor: "pointer",
  },
  summary: {
    maxWidth: "1100px",
    margin: "0 auto 0.6rem",
    color: "#374151",
    fontSize: "0.9rem",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "1rem",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    maxWidth: "1100px",
    margin: "0 auto",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  emptyCell: {
    padding: "1.4rem",
    textAlign: "center",
    color: "#6b7280",
  },
  th: {
    padding: "12px",
    background: "#f3f4f6",
    color: "#1f2937",
    fontSize: "0.9rem",
    fontWeight: 700,
    textAlign: "left",
    borderBottom: "2px solid #d1d5db",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "11px 12px",
    fontSize: "0.9rem",
    color: "#374151",
    borderBottom: "1px solid #e5e7eb",
  },
  rowEven: {
    background: "#ffffff",
  },
  rowOdd: {
    background: "#f9fafb",
  },
};
